import React, { useState, useCallback, useEffect } from 'react';
import { PageHeader, Table } from 'antd';
import { useSessionStorage } from 'react-use';

import api from '../../utils/appApi';
import FiltersSection from '../../components/filtersSection';
import ErrorPage from '../ErrorPage';
import buildTableColumns from '../../utils/buildTableColumns';
import formattingFilters from '../../utils/formattingFilters';

const initialState = {
  columns: [],
  data: [],
  entity: '',
  filterable: {},
  filterable_operators: {},
  meta: { total: 0 },
  summary: {},
};

const initialParams = {
  page: 1,
};

const buildFilters = (filters) => {
  const builtFilters = {
    keyword: filters?.keyword,
  };

  filters.filters.forEach((filter) => {
    const temp_filter = formattingFilters(filter, filter.keyword, 'STRING');

    Object.keys(temp_filter).forEach((key) => {
      builtFilters[`filters[${key}]`] = temp_filter[key];
    });
  });

  return builtFilters;
};

const LandingRequestsPage = () => {
  const [data, setData] = useSessionStorage(
    'landing-requests-page-data',
    initialState,
  );
  const [params, setParams] = useState(initialParams);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async (query) => {
    setLoading(true);
    try {
      const { data: response } = await api.reportsPages.getPilotLandingRequests(
        query,
      );
      setData(response);
    } catch (err) {
      console.log('Error fetching pilot landing requests:', err);
      setError({
        status: err.response?.status,
        message: err.response?.data?.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchDataClb = useCallback(fetchData, [setData]);

  useEffect(() => {
    fetchDataClb();
  }, [fetchDataClb]);

  const onFiltersSubmit = (filters) => {
    const newParams = {
      ...params,
      page: 1,
      ...buildFilters(filters),
    };
    setParams(newParams);
    fetchDataClb(newParams);
  };

  const onFiltersClear = () => {
    setParams(initialParams);
    fetchDataClb(initialParams);
  }

  const onTableChange = (pagination, _, sorter, extra) => {
    const { action, ...rest } = extra;

    const newParams = {
      ...params,
      page: 1,
    };

    if (action === 'paginate') {
      newParams.page = pagination.current;
    }

    if (action === 'sort' && sorter.order) {
      newParams.sort_column = sorter.field;
      newParams.sort_direction = sorter.order;
    }

    setParams(newParams);
    fetchDataClb({ ...newParams });
  };

  if (error) {
    return <ErrorPage title="Pilot Landing Requests" error={error} />;
  }

  return (
    <PageHeader className="page-main-header" title="Pilot Landing Requests">
      <div className="filters-container">
        <FiltersSection
          filter_columns={data.columns}
          columnOptions={data.filterable}
          loading={loading}
          filter={data.filters}
          onSubmit={onFiltersSubmit}
          onClear={onFiltersClear}
        />
      </div>
      <div className="page-main-content">
        <Table
          rowKey="id"
          columns={buildTableColumns(data.columns)}
          dataSource={data?.data}
          onChange={onTableChange}
          loading={loading}
          pagination={{
            current: data?.meta?.current_page || 1,
            pageSize: data?.meta?.per_page || 25,
            total: data?.meta?.total || 0,
            showSizeChanger: false,
            showQuickJumper: true,
          }}
        />
      </div>
    </PageHeader>
  );
};

export default LandingRequestsPage;
